const ownLink = "https://opimisil.com/8kKG6XN3";

const blogs = [
  {
    id: 1,
    date: "2025-01-15",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Jak Využít Bonusy na GapaGroup na Maximum",
    descr:
      "Objevte, jak získat a efektivně využívat bonusy na GapaGroup pro větší šance na výhru.",
    fullText:
      "Bonusy na GapaGroup jsou navrženy tak, aby zlepšily váš herní zážitek. Ať už jste začátečník nebo zkušený hráč, bonusy mohou hrát klíčovou roli při zvýšení vašich šancí na výhru.\n\nPrvní krok je registrace na GapaGroup, která vám okamžitě zpřístupní uvítací bonus. Tento bonus je ideální pro seznámení se s platformou a zkoušení různých her.\n\nDalší výhodou jsou týdenní promo akce. Tyto nabídky se pravidelně mění a přinášejí atraktivní možnosti, jako jsou volná zatočení nebo cashback.\n\nAbyste získali maximum z bonusů, vždy si přečtěte jejich podmínky. Některé bonusy mají specifické požadavky, jako je minimální vklad nebo sázení.\n\nVyzkoušejte různé hry, které podporují bonusy. Některé automaty nebo stolní hry mohou přinášet vyšší návratnost z vašich bonusů.\n\nSprávná strategie je také klíčem k úspěchu. Doporučuje se začít s menšími sázkami a postupně je zvyšovat, jakmile získáte důvěru ve hru.\n\nNezapomeňte na odpovědné hraní. Vždy si nastavte své limity a nikdy nehrávejte pod tlakem.\n\nNakonec, sledujte novinky na blogu GapaGroup, kde najdete aktuální informace o bonusových nabídkách a strategiích.",
  },
  {
    id: 2,
    date: "2025-01-12",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Strategie pro Hraní Automatu Fortune Tiger",
    descr:
      "Tipy a triky, jak zvýšit své šance na výhru při hraní oblíbeného automatu Fortune Tiger.",
    fullText:
      "Fortune Tiger je jedním z nejoblíbenějších automatů na GapaGroup díky své jedinečné grafice a velkým výhrám.\n\nPrvním krokem k úspěchu je pochopení pravidel. Před začátkem hry se seznamte s výherními kombinacemi a speciálními funkcemi automatu.\n\nJednou z nejlepších strategií je využití bonusů, které GapaGroup nabízí. Volná zatočení nebo zvýšené šance na jackpot mohou výrazně zvýšit vaše výhry.\n\nHrajte pravidelně, abyste získali přístup k exkluzivním promo akcím. Tyto akce často obsahují bonusy, které jsou specifické pro Fortune Tiger.\n\nSoustřeďte se na svůj bankroll management. Nastavte si denní nebo týdenní limity a držte se jich, abyste se vyhnuli zbytečným ztrátám.\n\nZkoušejte různé sázky. Začněte s menšími částkami a postupně je zvyšujte, pokud máte pocit, že se vám daří.\n\nDalší výhodou Fortune Tiger jsou jeho speciální symboly. Tyto symboly mohou aktivovat bonusové hry, které přinášejí vyšší šance na výhru.\n\nNezapomeňte na zábavu. Hraní by mělo být především příjemným zážitkem, nikoliv pouze honbou za výhrou.\n\nSledujte náš blog pro další tipy a strategie pro Fortune Tiger a další hry na GapaGroup.",
  },
  {
    id: 3,
    date: "2025-01-10",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Průvodce Přihlášením na GapaGroup",
    descr: "Podrobný návod, jak se rychle a bezpečně přihlásit na GapaGroup.",
    fullText:
      "Přihlášení na GapaGroup je snadné a rychlé, pokud budete postupovat podle těchto kroků.\n\nNejprve navštivte oficiální webovou stránku GapaGroup a klikněte na tlačítko Přihlásit se. Tato možnost se nachází v pravém horním rohu stránky.\n\nPokud jste nový uživatel, musíte se nejprve zaregistrovat. Klikněte na tlačítko Registrovat, vyplňte požadované údaje a potvrďte svou e-mailovou adresu.\n\nJakmile máte účet, stačí zadat své přihlašovací údaje, jako je uživatelské jméno a heslo. Doporučuje se používat silné heslo pro maximální bezpečnost.\n\nPokud zapomenete heslo, klikněte na odkaz Zapomenuté heslo a postupujte podle instrukcí k jeho obnově.\n\nPo úspěšném přihlášení získáte přístup k široké nabídce her, bonusů a promo akcí. Užijte si plný zážitek z GapaGroup.\n\nDbejte na bezpečnost svého účtu. Nepoužívejte veřejné Wi-Fi sítě a pravidelně měňte své heslo.\n\nV případě problémů se přihlášením kontaktujte zákaznickou podporu GapaGroup. Jsou k dispozici 24/7 a rádi vám pomohou.\n\nSledujte náš blog pro další tipy a aktuality o funkcích GapaGroup a novinkách ve světě her.",
  },
  {
    id: 4,
    date: "2025-01-08",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Jak Hrát a Vyhrát v Aviator",
    descr: "Praktické rady, jak ovládnout oblíbenou hru Aviator na GapaGroup.",
    fullText:
      "Aviator je hra, která kombinuje strategii a rychlé rozhodování. Pokud chcete maximalizovat své šance na výhru, následujte tyto tipy.\n\nNež začnete hrát, pochopte pravidla. Cílem je správně načasovat ukončení sázky předtím, než letadlo zmizí z obrazovky.\n\nZačněte s menšími sázkami, abyste pochopili mechanismy hry. Postupně můžete své sázky zvyšovat, jakmile se cítíte jistější.\n\nVyužívejte bonusy, které nabízí GapaGroup. Tyto bonusy vám umožní hrát více kol a zvýšit své šance na výhru.\n\nČasování je klíčem k úspěchu. Sledujte pohyby letadla a rozhodněte se, kdy ukončit sázku, abyste maximalizovali své výhry.\n\nHrajte odpovědně a nastavte si limity. Tato strategie vám pomůže užít si hru bez zbytečných ztrát.\n\nExperimentujte s různými strategiemi, jako je konzervativní hra nebo agresivní sázky. Každá strategie má své výhody.\n\nNezapomeňte sledovat novinky na blogu GapaGroup pro další tipy a aktualizace o hře Aviator.\n\nPřipojte se k herní komunitě GapaGroup a sdílejte své zkušenosti s ostatními hráči. Společně můžete objevovat nové strategie a tipy.",
  },
  {
    id: 5,
    date: "2025-01-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Nejlepší Herní Tipy pro Začátečníky",
    descr:
      "Základní tipy, které vám pomohou začít vaše herní dobrodružství na GapaGroup.",
    fullText:
      "Začátky v herním světě mohou být náročné, ale s těmito tipy budete na GapaGroup úspěšní.\n\nPrvním krokem je vytvoření účtu. Registrace na GapaGroup je jednoduchá a rychlá.\n\nProzkoumejte nabídku her. Vyberte si hry, které vás nejvíce zajímají, a seznamte se s jejich pravidly.\n\nVyužívejte bonusy a promo akce. Tyto nabídky vám mohou pomoci zvýšit váš bankroll a umožnit delší hraní.\n\nNastavte si herní limity. Tento krok vám pomůže udržet kontrolu nad vaším herním rozpočtem.\n\nSledujte naše tipy a strategie na blogu GapaGroup. Najdete zde rady pro různé hry a informace o novinkách.\n\nHrajte odpovědně. Nikdy nehrajte pod tlakem nebo za peníze, které si nemůžete dovolit ztratit.\n\nZkoušejte různé strategie. Experimentujte s různými přístupy k hrám a najděte ten, který vám nejlépe vyhovuje.\n\nPřipojte se k naší komunitě. Sdílejte své zkušenosti a učte se od ostatních hráčů na GapaGroup.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
